<template>
  <div class="summary" :class="{ active }">
    <div ref="summary">
      <div class="stages">
        <div
          v-for="(stage, index) in stages"
          :key="index"
          class="stage"
          :class="{
            active: stages[index].active,
            valid: stages[index].valid,
          }"
          @click="handleClick(index)"
        >
          <span class="stage__title">{{ strings[index].title }}</span>
          <span class="stage__subtitle">{{ strings[index].subtitle }}</span>
        </div>
      </div>
      <button
        type="button"
        class="reset smdt-btn smdt-btn--secondary"
        @click="reset"
      >
        {{ __('Reset', 'smdt') }}
      </button>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapState, mapWritableState, mapActions } from 'pinia'
import { useStagesStore } from '../stores/stages'
import hcSticky from 'hc-sticky'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

export default {
  name: 'SummarySidebar',
  data() {
    return {
      active: false,
      strings: [
        {
          title: __('Stage 1:', 'smdt'),
          subtitle: __('Start address', 'smdt'),
        },
        {
          title: __('Stage 2:', 'smdt'),
          subtitle: __('Destination address', 'smdt'),
        },
        {
          title: __('Stage 3:', 'smdt'),
          subtitle: __('The move', 'smdt'),
        },
        {
          title: __('Stage 4:', 'smdt'),
          subtitle: __('The inventory', 'smdt'),
        },
        {
          title: __('Stage 5:', 'smdt'),
          subtitle: __('Prestation', 'smdt'),
        },
        {
          title: __('Stage 6:', 'smdt'),
          subtitle: __('Your contact details', 'smdt'),
        },
        {
          title: __('Stage 7:', 'smdt'),
          subtitle: __('Summary', 'smdt'),
        },
      ],
    }
  },
  computed: {
    ...mapWritableState(useStagesStore, ['currentStage']),
    ...mapState(useStagesStore, [
      'apiData',
      'stages',
      'currentStep',
      'canNext',
      'latestValidIndex',
      'isLastStep',
    ]),
  },
  mounted() {
    $('body').on('click', '.devis-sidebar-toggle', (e) => {
      this.active = !this.active
      $(e.target).toggleClass('active')

      if ($(e.target).hasClass('active')) {
        $(e.target).find('.vn-a-content').hide()
        $(e.target).find('.vn-a-icon').show()
      } else {
        $(e.target).find('.vn-a-content').show()
        $(e.target).find('.vn-a-icon').hide()
      }
    })

    let offset = 50
    const adminBar = document.getElementById('wpadminbar')
    if (adminBar) {
      offset += adminBar.clientHeight
    }

    if (window.matchMedia('(max-width: 991.98px)').matches) {
      offset += 100
    }

    new hcSticky(this.$refs.summary, {
      top: offset,
      bottom: 15,
      responsive: {
        767: {
          disable: true,
        },
      },
    })
  },
  methods: {
    ...mapActions(useStagesStore, [
      'reset',
      'goStep',
      'isValid',
      'setValidated',
    ]),
    __,
    handleClick(clickedIndex) {
      const currentIndex = this.currentStep

      if (!this.canNext && clickedIndex > currentIndex) {
        this.setValidated(true)
      }

      if (this.canNext && currentIndex + 1 === clickedIndex) {
        this.goStep(clickedIndex)
        return
      }

      if (this.canNext && this.latestValidIndex + 1 === clickedIndex) {
        this.goStep(clickedIndex)
        return
      }

      if (this.canNext && this.isValid(clickedIndex)) {
        this.goStep(clickedIndex)
        return
      }

      if (
        this.canNext &&
        this.isValid(clickedIndex) &&
        clickedIndex < currentIndex &&
        this.latestValidIndex + 1 === currentIndex
      ) {
        this.goStep(clickedIndex)
        return
      }

      if (this.isValid(clickedIndex) && this.isLastStep) {
        this.goStep(clickedIndex)
        return
      }
    },
  },
}
</script>

<style scoped lang="scss">
.stage-4 {
  .summary {
    @include media-breakpoint-down(lg) {
      padding: 150px 20px 75px;
    }

    @include media-breakpoint-down(md) {
      padding: 40px 50px;
    }
  }
}

.summary {
  flex: 0 0 auto;
  width: 400px;
  background-color: #fff;
  padding: 150px 50px;
  overflow-x: hidden;
  overflow-y: auto;

  &.active {
    @include media-breakpoint-down(md) {
      transform: none;
    }
  }

  @include media-breakpoint-down(lg) {
    padding: 50px 20px 75px;
    width: 300px;
  }

  @include media-breakpoint-down(md) {
    width: 100%;
    transform: translateX(-100%);
    position: fixed;
    top: var(--wp-adminbar-height);
    bottom: 60px;
    z-index: 100;
    left: 0;
    transition: transform 250ms;
    padding: 40px 50px;
  }
}

.stage {
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  cursor: pointer;
  font-size: 16px;
  border-left: 2px solid transparent;
  transition:
    padding-left 250ms,
    border-left-color 250ms;

  &.active {
    color: var(--vn-secondary-color);
    padding-left: 10px;
    border-left-color: var(--vn-secondary-color);
  }

  &.valid {
    color: var(--vn-success-color);
    border-color: var(--vn-success-color);

    &:not(.active) {
      border-left-color: transparent;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }

  &__title {
    display: block;
    font-weight: 700;
    transition: color 250ms;
  }

  &__subtitle {
    display: block;
    transition: color 250ms;
  }
}

.reset {
  margin-top: 30px;
  min-width: 100px;
}
</style>
